export const PRODUCT_IMAGE_PLACEHOLDER_PATH = '/images/icons/product-placeholder.svg';
